module.exports = __webpack_public_path__ + "workspace/static/img/tenantMgmtMasterMsspTwo.187a2b9.png";